import { render } from "./TheRoleReport.vue?vue&type=template&id=9ea8751c"
import script from "./TheRoleReport.vue?vue&type=script&lang=js"
export * from "./TheRoleReport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__